export type DestinationKind = "space" | "collection" | "saved-view";

export interface DestinationRef {
  kind: DestinationKind;
  id: string;
  rootId?: string;
}

export function destinationKey(destination: DestinationRef): string {
  return `${destination.kind}:${destination.id}`;
}

export function toggleFavorite(favorites: DestinationRef[], destination: DestinationRef): DestinationRef[] {
  const key = destinationKey(destination);
  return favorites.some(item => destinationKey(item) === key)
    ? favorites.filter(item => destinationKey(item) !== key)
    : [...favorites, destination];
}

export function rememberDestination(recent: DestinationRef[], destination: DestinationRef, limit = 5): DestinationRef[] {
  const key = destinationKey(destination);
  return [destination, ...recent.filter(item => destinationKey(item) !== key)].slice(0, limit);
}

export function pruneDestinations(items: DestinationRef[], valid: Set<string>): DestinationRef[] {
  return items.filter(item => valid.has(destinationKey(item)));
}
